import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-bottom">
        <span>© 2026 OnBox. Todos os direitos reservados.</span>
      </div>
    </footer>
  );
}